import React,{useEffect,useState} from "react";
import API from "../services/api";
import "./Attendance.css";;

export default function UserAttendance(){

const [attendance,setAttendance]=useState([]);
const [selectedYear,setSelectedYear]=useState("2025");

useEffect(()=>{

fetchAttendance();

},[selectedYear]);

const fetchAttendance=async()=>{

try{

const employeeName=
localStorage.getItem("username") || "";

console.log(
"Logged User:",
employeeName
);

let url = `/invoice/attendance?year=${selectedYear}`;

if (employeeName) {
  url += `&employeeName=${employeeName}`;
}

const res = await API.get(url);

console.log(
"Attendance Response:",
res.data
);

setAttendance(res.data);

}catch(err){

console.log(err);

}

};

const years=[2025,2026];

return(

<div className="container">

<h1>
My Attendance
</h1>

<div style={{marginBottom:"20px"}}>

<label>
Select Year :
</label>

<select
value={selectedYear}
onChange={(e)=>
setSelectedYear(e.target.value)
}
style={{
marginLeft:"10px",
padding:"5px"
}}
>

{years.map(year=>(

<option
key={year}
value={year}
>

{year}

</option>

))}

</select>

</div>

<table
>

<thead>

<tr>

<th>Month</th>
<th>Hours</th>
<th>Rate</th>
<th>Total Amount</th>

</tr>

</thead>

<tbody>

{attendance.length>0 ? (

attendance
  .filter(item =>
    !["Job Title", "Year", "Department"].includes(item.month)
  )
  .map((item, index) => (

<tr key={index}>

<td>{item.month}</td>
<td>{item.hours}</td>
<td>₹ {item.rate}</td>
<td>₹ {item.total}</td>

</tr>

))

) : (

<tr>

<td
colSpan="4"
style={{
textAlign:"center"
}}
>

No Attendance Found

</td>

</tr>

)}

</tbody>

</table>

</div>

);

}